import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-differently-abled',
  templateUrl: './differently-abled.component.html',
  styleUrls: ['./differently-abled.component.scss']
})
export class DifferentlyAbledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
